exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "a {\n  color: #2db7f5;\n  text-decoration: none;\n}\n", "", {"version":3,"sources":["D:/ZjgHm/furuicode/frui_backend/front/src/components/WebSiteLayout/Menu.less"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,sBAAsB;CACvB","file":"Menu.less","sourcesContent":["a {\n  color: #2db7f5;\n  text-decoration: none;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?sourceMap!./node_modules/less-loader/dist/cjs.js?{"javascriptEnabled":true}!./src/components/WebSiteLayout/Menu.less
// module id = 1276
// module chunks = 0